// extracted by mini-css-extract-plugin
export default {"news":"ExKYbEOj","mobile":"mobile","news__link":"BxkTqr06","main":"ydKUlfC1","desktop":"desktop","rubric":"rCa72IMB","rubric__bg":"ddibVXT7","rubric__content":"cNrUslHQ"};